import { schema } from 'normalizr';

const pipelineStageSchema = new schema.Entity('pipelineStages', {
  contacts: [new schema.Entity('contacts', {})],
  pipeline: new schema.Entity('pipelines', {}),
});

export default pipelineStageSchema;
